import React, { Component } from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { GeoAltFill } from 'react-bootstrap-icons';
import YearsDeltaImage from '../../images/Years_Delta.png';

export class YearsDelta extends Component {
    render() {
        const popover = (
            <Popover className="popover-basic">
                <Popover.Title as="h3">Years Delta</Popover.Title>
                <Popover.Content>
                    <img src={YearsDeltaImage} className="popover-images" alt="Puzzle Calculator Digits" />
                </Popover.Content>
            </Popover>
        );

        return (
            <OverlayTrigger
                trigger="click"
                placement="auto"
                overlay={popover}
                rootClose={true}
                transition={false}
                onToggle={() => this.setState({ error: null })}
            >
                <div className="game-icons years-Delta" style={this.props.positioning}>
                    <GeoAltFill alt="Years Delta Clue" />
                </div>
            </OverlayTrigger>
        )
    }
}

export default YearsDelta
